import React, { useEffect } from 'react';
import { useAuth } from '../features/auth/useAuth';
import { applyCachedDocumentBranding } from '../utils/settingsBranding';

/** Applies favicon link tags and document title from encrypted settings cache after auth sync. */
export const AppDocumentHead: React.FC = () => {
  const { isAuthLoading, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthLoading || !isAuthenticated) return;
    void applyCachedDocumentBranding();
  }, [isAuthLoading, isAuthenticated]);

  return null;
};
